export const TEST_CUSTOM_THEME = {
  background: '#ffffff',
  'background-hover': '#f5f5f5',
  'page-background': '#fafafa',
  text: '#1f2937',
  'text-light': 'rgba(107, 114, 128, 0.6)',
  border: 'rgba(209, 213, 219, 0.8)',
  shadow: 'rgba(0, 0, 0, 0.05)',
  'primary-color': '#1677FF',
  'button-radius': '12px',
};

export const TEST_CUSTOM_LAYOUT = 'spacious';

export default {
  TEST_CUSTOM_THEME,
  TEST_CUSTOM_LAYOUT,
};
